
import {Avatar, Badge, Box, Flex, Heading, Image} from "@chakra-ui/react"
import React from "react";
import {getTagInfoFromTagId, getUrlImgFromTagId} from "../../tag/tools";
import TagContentHot from "../../tag/components/TagContentHot";
import {motion} from "framer-motion";
import PartiCardItem from "../../partis/components/PartiCardItem";
import TagItemHeader from "../../tag/components/TagItemHeader";
import {HeaderSection} from "../../mainPage/HeaderSection";
import {LOG} from "../../tools";

const MotionHeading = motion(Heading)

const PersonHeader = ({id,name,dataHeader})=>{

    const listParti = getTagInfoFromTagId(id)["pp"]

    const urlImg =  getUrlImgFromTagId(id,400)

    return <div>
        <Flex sx={{justifyContent:'center',flexWrap:'wrap',mt:['16px','64px','128px']}}>
            <div><Image src={urlImg} borderRadius="full"
  boxSize="250px"
            /></div>
            <Box sx={{width:["100%","60%","80%"],p:'10px'}}>
                <Flex sx={{justifyContent: 'flex-start'}}>
                 <Box sx={{width:'15px', bg:'bg.900'}}/>  <MotionHeading as={"h1"} sx={{}} animate={{x:-5}}>{name}</MotionHeading>
                </Flex>

                <Box sx={{p:2, minHeight:250}}>

                    <Flex>
                    {listParti.map((partiId) =><PartiCardItem
                        key ={partiId}
                        tagId={partiId} /> ) }
                    </Flex>
                <Box>
                    <HeaderSection  text={"Résumé sur 3 semaines"} flexGrowRight={25} />

                <Flex mt={0} flexWrap={"wrap"} width={"100%"}>
                    <TagItemHeader typeInfo={"nb"} data={dataHeader} widthCard={["100%","40%","25%"]}/>
                    <TagItemHeader typeInfo={"vocab"} data={dataHeader} widthCard={["100%","60%","75%"]}/>
                </Flex>
            </Box>

                </Box>

            </Box>
        </Flex>
    </div>
}
export default PersonHeader